var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:'indexModelTitle' + _vm.refAnimal,staticClass:"info",style:({ backgroundColor: _vm.backgroundColor, color: _vm.fontColor})},[_c('div',[_c('h3',{class:_vm.titleClass},[_vm._v(_vm._s(_vm.title))]),_c('p',{class:_vm.descClass},[_vm._v(_vm._s(_vm.content1))]),_c('p',{class:_vm.descClass},[_vm._v(_vm._s(_vm.content2))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }